
// THIS IS A GENERATED FILE
export const environment = {
  production: true,
  version: 'fa489f077a78f0a01f03381a5133f45bab4eafc4',
  base_url: 'https://api.kahi.io',
  web_url: 'https://app.kahi.io',
  ws_url: 'wss://api.kahi.io/ws',
  mapbox_access_token: 'pk.eyJ1Ijoia2FoaS10ZWNob3BzIiwiYSI6ImNrOWthNjE1bDBmbWozcnMxbng3eWk1dXAifQ.rFUKNxj7sPGSIgqZ9qF-4A',
  sentry_dsn: 'https://182231ba11534b9e8137ee267e8bcdfe@o173771.ingest.sentry.io/4504137083060224',
  sentry_env: 'production',
  show_crash_dialog: false
};
